/* @flow */

import type { Storage } from "crustate";
import type { Client } from "@awardit/graphql-ast-client";

import {
  PHOTO_SERVICE_LIST_REQUEST,
  PHOTO_SERVICE_LIST_RESPONSE,
} from "state/photo-service-list";

import { photoServiceList } from "queries";

const registerClient = (storage: Storage, client: Client<{}>) => {
  storage.addEffect({
    effect: async (_, path) => {
      try {
        const data = await client(photoServiceList);

        storage.replyMessage({
          tag: PHOTO_SERVICE_LIST_RESPONSE,
          data: data.photoServiceList,
        }, path);
      }
      catch (e) {
        console.error(e);

        return ({
          tag: PHOTO_SERVICE_LIST_RESPONSE,
          error: "Error in photo service list effect",
        });
      }
    },
    subscribe: { [PHOTO_SERVICE_LIST_REQUEST]: true },
  });
};

export default registerClient;
